import uniqBy from 'lodash/uniqBy';
import genererGuid from '@/services/general/genererGuid';

function formatData(data) {
  return {
    data,
    id: data.id,
    libelle: data.nomCommercial || data.libelle,
    children: [],
    selected: false,
    openSecteur: false,
  };
}

function compare(a, b) {
  if (a.libelle.toLowerCase() < b.libelle.toLowerCase()) {
    return -1;
  }
  if (a.libelle.toLowerCase() > b.libelle.toLowerCase()) {
    return 1;
  }
  return 0;
}

function getLogo(tiers) {
  let urlLogo = tiers.chemin;
  if (!urlLogo && tiers.tiersParentId) {
    urlLogo = tiers.tiersParent.chemin;
  }
  if (!urlLogo && tiers.tiersParent && tiers.tiersParent.tiersParentId) {
    urlLogo = tiers.tiersParent.tiersParent.chemin;
  }
  return urlLogo;
}

export default function formatageConcurrents(pdvs, secteurActiviteId) {
  const data = [];
  const secteursActivitesEnseigne = pdvs
    .filter(p => p.tiersParent && p.tiersParent.secteurActivite)
    .map(p => p.tiersParent.secteurActivite);
  const secteursActivitesPdv = pdvs
    .filter(p => p.secteurActivite)
    .map(p => p.secteurActivite);
  const secteursActivites = uniqBy(secteursActivitesEnseigne.concat(secteursActivitesPdv), 'id');
  const pdvsFormat = pdvs.map(p => {
    let marque = null;
    let secteur = null;
    if (p.tiersParentId) {
      marque = p.tiersParent.marque;
      secteur = p.tiersParent.secteurActivite ? p.tiersParent.secteurActivite.id : null;
    } else {
      marque = p.marque;
      secteur = p.secteurActiviteId;
    }
    return {
      id: p.id,
      secteurActiviteId: secteur,
      marque: marque,
      libelle: p.nomCommercial,
      coordonnees: {
        lat: p.adressePostale.latitude,
        lng: p.adressePostale.longitude,
      },
      urlLogo: getLogo(p),
    };
  }).filter(el => el.secteurActiviteId);

  secteursActivites.forEach(secteur => {
    const pdvsSecteur = pdvsFormat.filter(p => p.secteurActiviteId === secteur.id);

    const marques = uniqBy(pdvsSecteur.filter(p => p.marque && p.marque !== '')
      .map(p => ({ libelle: p.marque.trim(), id: genererGuid() })), 'libelle')
      .map(formatData).sort(compare);
    marques.forEach(marque => {
      marque.children = pdvsSecteur
        .filter(p => p.marque && p.marque !== '' && p.marque.trim() === marque.libelle)
        .map(formatData)
        .sort(compare);
    });
    const pdvsWithoutMarque = pdvsSecteur.filter(p => !p.marque)
      .map(formatData)
      .map(p => ({ ...p, isPdv: true }))
      .sort(compare);

    data.push({
      ...formatData(secteur),
      children: [...marques, ...pdvsWithoutMarque],
    });
  });
  const dataSort = data.filter(el => el.children.length).sort(compare);
  if (secteurActiviteId) {
    const index = dataSort.findIndex(el => el.id === secteurActiviteId);
    if (index !== -1) {
      const currentSecteur = dataSort[index];
      currentSecteur.selected = true;
      currentSecteur.openSecteur = true;
      currentSecteur.children.forEach(el => {
        el.selected = true;
        el.children.forEach(c => {
          c.selected = true;
        });
      });
      dataSort.splice(index, 1);
      dataSort.unshift(currentSecteur);
    }
  }
  return dataSort;
}
